export default __webpack_public_path__ + "static/media/slider5.92d07811.jpg";